import { createApp } from 'vue'
import App2 from './App2.vue'

createApp(App2).mount('#app')
